import { render, staticRenderFns } from "./UsuarioRepresentante.vue?vue&type=template&id=ab4f405c&scoped=true&"
import script from "./UsuarioRepresentante.vue?vue&type=script&lang=js&"
export * from "./UsuarioRepresentante.vue?vue&type=script&lang=js&"
import style0 from "./UsuarioRepresentante.vue?vue&type=style&index=0&id=ab4f405c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab4f405c",
  null
  
)

export default component.exports